import React, { Component } from 'react';
import './radioGroup.scss';
import { Input, Dropdown } from '../../UiKit';
import { Card } from '../../components/widgets/ReportIssue/Issues/common';
import { Check, Info } from 'lucide-react';

export default class RadioGroup extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption: null,
      showInput: '',
      inputVal: '',
      inputLimitError: false,
      showDropdown: false,
    };
  }

  removeOldSelection = (items) => {
    return items?.forEach((element) => {
      delete element?.selectedValue;
      delete element?.error;
      return true;
    });
  };

  onRadioSelect(item, event) {
    const { selectOption, items, radio = null } = this.props;
    const value = event.target.value;
    if (item.disabled) return;
    this.removeOldSelection(items);

    this.setState({
      selectedOption: value,
      showInput: item.input_box ? item.value : '',
      inputVal: '',
      showDropdown: item.dropdown ? true : false,
    });
    if (radio) {
      radio['selectedValue'] = value;
    }
    selectOption(value, item, radio);
  }

  onInputChange = (item, value) => {
    const { onRadioInputChange } = this.props;
    delete item.error;
    if (item.format === 'number' && Number(value) > Number(item.max_limit)) {
      this.setState({
        inputLimitError: true,
      });
      onRadioInputChange(null);
      return false;
    } else {
      item['selectedInputValue'] = value;
      this.setState({
        inputLimitError: false,
        inputVal: value,
      });
    }
    onRadioInputChange(value);
  };

  getDropDownvalues = (data) => {
    const dropDownValues = {};
    data.items &&
      data.items.map((item) => {
        dropDownValues[item.id] = item.title;
        return true;
      });
    return dropDownValues;
  };

  onSelect = (item, value) => {
    const { selectDropdown } = this.props;
    delete item.dropdown.error;
    item.dropdown['selectedDropdownValue'] = value;
    return selectDropdown(value);
  };

  render() {
    const {
      items,
      error,
      errorText,
      showMaxLimit = false,
      selectedDropdownVal,
      dropdownError,
      dropdownErrorText,
      radioGroupWidth = '',
      showRadioOptionDetailsCard = 'always',
    } = this.props;
    const {
      selectedOption,
      showInput,
      inputVal,
      inputLimitError,
      showDropdown,
    } = this.state;
    if (!items) return null;
    const inputNoteError = inputLimitError ? 'inputNoteError' : '';

    return (
      <div className='radioGroup' style={{ width: radioGroupWidth }}>
        {items.map((item, index) => {
          if (!item) return null;
          return (
            <React.Fragment key={index}>
              <label
                key={index}
                className={`${
                  item.disabled
                    ? 'pointerDisabled !tw-bg-white tw-cursor-not-allowed'
                    : [
                        'tw-cursor-pointer',
                        '!tw-shadow-none',
                        (
                          selectedOption
                            ? String(selectedOption) === String(item.value)
                            : item?.selected
                        )
                          ? 'tw-outline tw-outline-grey-200 !tw-bg-white'
                          : 'hover:tw-outline hover:tw-outline-grey-200 !tw-bg-white',
                      ]
                        .filter(Boolean)
                        .join(' ')
                }`}
              >
                <input
                  className='green'
                  type='radio'
                  checked={
                    selectedOption
                      ? String(selectedOption) === String(item.value)
                      : item?.selected
                  }
                  value={item.value}
                  disabled={item.disabled}
                  onChange={this.onRadioSelect.bind(this, item)}
                />
                <div className='radioLabel'>
                  <span className='radioIcon'></span>
                  <div className='tw-flex tw-flex-col'>
                    <div className='tw-flex tw-items-center tw-gap-2'>
                      <span
                        style={{
                          color: item?.disabled ? '#9C9C9C' : item.color,
                          fontWeight: item.type,
                        }}
                        className='tw-font-medium tw-text-zinc-800'
                      >
                        {item.text}
                      </span>
                      <InfoTooltip item={item} />
                    </div>
                    {item.sub_text && (
                      <div
                        style={
                          item?.st_style
                            ? { ...item?.st_style }
                            : { color: item.st_color }
                        }
                        className='tw-leading-tight tw-mt-2'
                      >
                        {item.sub_text}
                      </div>
                    )}
                    {item.enable_reason && (
                      <div
                        style={
                          item?.er_style
                            ? { ...item?.er_style }
                            : { color: item.er_color }
                        }
                        className='tw-flex tw-items-center tw-gap-1 tw-leading-none tw-mt-3 tw-p-[0.5rem] tw-rounded-lg tw-bg-[#EDFAF1] tw-w-fit tw-text-[1.2rem]'
                      >
                        <Check size={14} className='tw-text-base-green' />
                        {item.enable_reason}
                      </div>
                    )}
                  </div>
                </div>
                {showRadioOptionDetailsCard === 'isChecked'
                  ? String(selectedOption) === String(item.value) &&
                    item?.radioOptionDetailsCard
                  : item?.radioOptionDetailsCard}
              </label>
              {item.input_box && showInput === item.value && (
                <div className='inputContainer'>
                  <Input
                    placeholder={item.input_box.placeholder}
                    value={inputVal}
                    type={item.input_box.format}
                    onChange={this.onInputChange.bind(this, item.input_box)}
                    error={error}
                    errorText={errorText}
                    inputLimitError={inputLimitError}
                    showMaxLimit={showMaxLimit}
                  />
                  <p className={`light note small ${inputNoteError}`}>
                    {item.input_box.note}
                  </p>
                </div>
              )}
              {item.dropdown && showDropdown && (
                <div className='itemsDropdown pb20'>
                  <Dropdown
                    dropDownValues={this.getDropDownvalues(item.dropdown)}
                    onSelect={this.onSelect.bind(this, item)}
                    dropdownVal={selectedDropdownVal}
                    itemSize='12px'
                    placeholder='Select the issue'
                    error={dropdownError}
                    errorText={dropdownErrorText}
                  />
                </div>
              )}
              {item.card && (
                <div className='pb10'>
                  <Card content={item.card} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const InfoTooltip = ({ item }) => {
  if (!item || !item.reason) return null;

  return (
    <div className='tw-flex tw-justify-center tw-relative tw-group'>
      <div
        className={`tw-absolute tw-bottom-7 -tw-right-10 tw-w-[22rem] tw-z-50 tw-bg-grey-050 tw-text-grey-600 tw-text-[1.3rem] tw-border tw-border-grey-300 tw-shadow-sm
tw-font-medium tw-px-2 tw-py-2 tw-rounded-md tw-border-solid
tw-opacity-0 group-hover:tw-opacity-100 tw-scale-95 group-hover:tw-scale-100
tw-transition-all tw-duration-200 tw-ease-in-out tw-pointer-events-none tw-leading-tight`}
      >
        {item.reason}
      </div>
      <Info
        size={14}
        className='tw-text-grey-900 group-hover:tw-scale-105 tw-transition-all tw-duration-200 tw-ease-in-out tw-pointer-events-none'
      />
    </div>
  );
};
